'use client';

import NextLink from 'next/link';

import { BackButton } from '../../atomic-atoms';
import secondaryStyles from '../../atomic-atoms/buttons/SecondaryButton.module.scss';

import styles from './PageHeaders.module.scss';

export type PageDetailHeaderProps = {
  title: string;
  editHref: string;
  editText?: string;
  editAriaLabel?: string;
  onBack?: () => void;
};

export function PageDetailHeader({
  title,
  editHref,
  editText = 'Edit',
  editAriaLabel = 'Edit',
  onBack,
}: PageDetailHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <BackButton onClick={onBack} />
        <h1 className={styles.title}>{title}</h1>
      </div>

      <div className={styles.headerRight}>
        <NextLink
          href={editHref}
          className={`button-base ${secondaryStyles.secondaryButton} ${secondaryStyles.full}`}
          aria-label={editAriaLabel}
        >
          {editText}
        </NextLink>
      </div>
    </header>
  );
}
